<template>
  <div class="box online_bg">
    <v-dialog/>
    <div class="wrap w1200">
      <!--右侧列表-->
      <div class="onsite_b task_jihua_detail">
        <!--顶部详情-->
        <div class="top_con">
          <p class="back_btn">
            <a onclick="history.go(-1)">返回</a>
          </p>
          <dl>
            <dt>
              <img src="@/assets/images/zy_2.jpg" v-if="!coverUrl || coverUrl == ''" />
              <img :src="coverUrl" v-if="coverUrl">
            </dt>
            <dd>
              <h3 style="font-weight: 700;">{{planTitle}}
                <span v-if="form.price && form.price > 0">￥<span style="color: #ff3633;
    font-size: 24px;">{{form.price}}</span>元</span>
                <span v-if="!form.price || form.price <= 0" style="display: inline-block; font-size: 14px; line-height: 14px; background: #ff3633; border-radius: 5px; color: white; padding: 5px;">免费</span>
              </h3>
              <p class="time">{{ dateFormat(new Date(trainingPlan.beginDate), 'yyyy-MM-dd hh:mm:ss') }} 至 {{ dateFormat(new Date(trainingPlan.endDate), 'yyyy-MM-dd hh:mm:ss') }}</p>
              <a class="btn_go">总进度 {{form.process}}%</a>
            </dd>
          </dl>
        </div>
        <!--/顶部详情-->
        <!--tab-->
        <ul class="tabs" style="margin-left: 0; margin-right: 0;">
          <li class="tab_item" @click="panel = '1'"><a :class="{current: panel=='1'}">培训内容</a></li>
          <li class="tab_item" @click="panel = '3'"><a :class="{current: panel=='3'}">证书</a></li>
        </ul>
        <!--/tab-->
        <div class="tab_content">
          <!--培训内容-->
          <div v-if="panel == '1'" class="tab1_3 pxcon_list w1080">
            <dl v-for="item in planItemList" v-bind:key="item.id" style="position: relative;">
              <dt>
                <span>{{getPlanType(item.type)}}</span>
                <a>
                  <img src="@/assets/images/course_default.png" v-if="!item.coverUrl || item.coverUrl == ''" />
                  <img :src="item.coverUrl" v-if="item.coverUrl && item.coverUrl !== ''">
                </a>
              </dt>
              <dd style="width: 795px;">
                <h4>{{item.name}}<span v-if="item.isElective == '0'">选修</span><span v-if="item.isElective == '1'">必修</span></h4>
                <p class="px_text">需要完成学分：{{item.credit}}</p>
                <p v-html="item.introduction" class="px_sm"></p>
                <p class="px_text">当前进度：{{ getProcess(item.itemId) }}%</p>
              </dd>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/courseDetail', item)" v-if="item.type=='00' && getProcess(item.itemId) == 100">课程已完成</a>
              <a style="cursor: pointer;" class="detail_btn" v-if="item.type=='01'  && getProcess(item.itemId) == 100">考试已完成</a>
              <a style="cursor: pointer;" class="detail_btn" v-if="item.type=='02'  && getProcess(item.itemId) == 100">问卷已完成</a>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/courseDetail', item)" v-if="item.type=='00' && Number(getProcess(item.itemId)) > 0 && Number(getProcess(item.itemId)) < 100">继续学习</a>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/examReady', item, '1')" v-if="item.type=='01'  && Number(getProcess(item.itemId)) > 0 && Number(getProcess(item.itemId)) < 100">继续考试</a>
              <a style="cursor: pointer;" class="detail_btn" @click="doQuestionnaire(item, '1')" v-if="item.type=='02'  && Number(getProcess(item.itemId)) > 0 && Number(getProcess(item.itemId)) < 100">继续回答</a>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/courseDetail', item)" v-if="item.type=='00' && getProcess(item.itemId) == 0">开始学习</a>
              <a style="cursor: pointer;" class="detail_btn" @click="to(path + '/examReady', item, '1')" v-if="item.type=='01'  && getProcess(item.itemId) ==  0">开始考试</a>
              <a style="cursor: pointer;" class="detail_btn" @click="doQuestionnaire(item, '1')" v-if="item.type=='02'  && getProcess(item.itemId) ==  0">回答问卷</a>
            </dl>
          </div>
          <!--/培训内容-->
          <div v-if="panel == '3'" class="tab1_4 w1080 px_con">
            <div v-if="!form.result">请完成所有内容后获取证书</div>
            <div v-if="form.result">
              <!--CertView :id="cert.id" :p="labelsMap" :w="1080" v-if="cert"></CertView-->
              <img :src="cert" alt="" width="800">
            </div>
          </div>
        </div>
      </div>
      <!--/右侧列表-->
      <div class="clear"></div>
    </div>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import utils from '@/utils'
  // import CertView from '@/page/byl/org/cert/display.vue'
  import difference from 'lodash.differenceby'
  import { getCookie } from '@/store/cookies.js'
  export default {
    components: { },
    props: ['path'],
    data () {
      return {
        panel: '1',
        form: {},
        planTitle: '',
        coverUrl: '',
        planItemList: [],
        planUserItemMap: {},
        cert: '', // 证书地址
        labelsMap: {},
        examPaperInfo: {},
        trainingPlan: {}
      }
    },
    created () {
      this.getModel({id: this.$route.params.id, planId: this.$route.params.planId})
    },
    mounted () {
      this.$on('data-prepared', function (data) {
        this.planTitle = data.trainingPlan.title
        this.coverUrl = data.trainingPlan.coverUrl
        this.trainingPlan = data.trainingPlan
        this.planUserItemMap = data.planUserItemMap
        this.certRequired = !!data.trainingPlan.certId
        if (data.result == 'pass' && this.certRequired) { // 通过并且需要证书
          this.generateCert({
            itemId: data.planId,
            itemType: '05'
          })
        }
        let resultArr
        if (this.form.learningOrder == '0') { // 有序
          resultArr = utils.sortByKey(data.trainingPlan.planItemList, 'sort')
        } else { // 无序
          resultArr = this.sortFinished(data.trainingPlan.planItemList)
        }
        this.planItemList = resultArr
      });
    },
    methods: {
      findElem: utils.findElem,
      dateFormat: utils.dateFormat,
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: o.title,
          text: o.text,
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      getPlanType (type) {
        switch (type) {
          case '00': {
            return '课程';
          }
          case '01': {
            return '考试';
          }
          case '02': {
            return '问卷';
          }
        }
      },
      getModel (o) {
        if (o.id == 'undefined') { delete o.id }
        api.post(config.bylApiPath, '/planUsers/getOne', o, (r) => { // 正常
          this.form = r.data
          this.$emit('data-prepared', this.form)
        })
      },
      getProcess (itemId) { // 取得单项内容进度
        var p = 0;
        for (let i in this.planUserItemMap) {
          var o = this.planUserItemMap[i]
          if (o.itemId == itemId) {
            p = o.process
          }
        }
        return p;
      },
      getRecordId (itemId) { // 取得单项内容进度
        var p;
        for (let i in this.planUserItemMap) {
          var o = this.planUserItemMap[i]
          if (o.itemId == itemId) {
            p = o.id
          }
        }
        return p;
      },
      getItemRecordIdBy (itemId) {
        var p;
        for (let i in this.planUserItemMap) {
          var o = this.planUserItemMap[i]
          if (o.itemId == itemId) {
            p = o.id
          }
        }
        return p;
      },
      getCertById (id) {
        var that = this
        this.$api.post(this.$global.certApiPath, '/cert-templates/search', {includedIds: ids, isPublished: '1'}, r => {
          that.certList = r.data
          if (that.certList) {
            that.cert = that.certList[0]
          }
        })
      },
      generateCert (o) {
        api.post(config.bylApiPath, '/cert/generate', o, (r) => { // 正常
          this.cert = r.data
          /* if (r.data.certTemplatePointLoactionList) { // 前端自己显示的话调用这一段
            for (let i = 0; i < r.data.certTemplatePointLoactionList.length; i++) {
              let o = r.data.certTemplatePointLoactionList[i]
              this.labelsMap[o.pointKey] = o.pointValue || ''
            }
          } */
        })
      },
      sequenceCheck (item) {
        var that = this
        return new Promise(function (resolve, reject) {
          that.$api.post(that.$global.bylApiPath, '/planUsers/checkLearningSequence/' + item.itemId, {planTitle: item.name, id: that.form.id, planId: item.planId}, r => {
            resolve(r.data)
          })
        })
      },
      planDateCheck () {
        let stime = this.dateFormat(new Date(this.form.trainingPlan.beginDate), 'yyyy-MM-dd')
        let etime = this.dateFormat(new Date(this.form.trainingPlan.endDate), 'yyyy-MM-dd')
        let rangeCheck = this.$utils.dateInRange(stime, etime)
        return rangeCheck
      },
      to (path, item, type) {
        var that = this
        var _go2itemPage = function () {
          if (type) {
            that.$router.push({
              path: path + '/' + item.itemId + '/' + type,
              query: {
                pid: that.getItemRecordIdBy(item.itemId)
              }
            })
          } else {
            that.$router.push({
              path: path + '/' + item.itemId
            })
          }
        }
        if (getCookie(process.env.TOKEN_KEY)) {
          let rangeCheck = this.planDateCheck()
          if (rangeCheck.inRange) {
            if (this.form.trainingPlan.learningOrder == '0') { // 如需顺序学习
              this.sequenceCheck(item).then(function (isValid) {
                if (isValid) {
                  _go2itemPage()
                } else {
                  that.$toasted.show('该项学习任务需要在前一项学习任务完成后才能学习')
                }
              });
            } else {
              _go2itemPage()
            }
          } else {
            this.$toasted.show('该计划' + rangeCheck.msg)
          }
        } else {
          this.$toasted.show('请先登录')
        }
      },
      doQuestionnaire (item, type) {
        var that = this
        var _go2itemPage = function () {
          that.$api.post(that.$global.examApiPath, '/examPaper/searchByUser', {id: item.itemId}, r => { // 生成examId
            if (r.data) {
              that.examPaperInfo = r.data[0]
              that.startQuestionnaire(that.examPaperInfo, type, item.itemId)
            }
          })
        }
        if (getCookie(process.env.TOKEN_KEY)) {
          let rangeCheck = this.planDateCheck()
          if (rangeCheck.inRange) {
            if (this.form.trainingPlan.learningOrder == '0') { // 如需顺序学习
              this.sequenceCheck(item).then(function (isValid) {
                if (isValid) {
                  _go2itemPage()
                } else {
                  that.$toasted.show('该项学习任务需要在前一项学习任务完成后才能学习')
                }
              });
            } else {
              _go2itemPage()
            }
          } else {
            this.$toasted.show('该计划' + rangeCheck.msg)
          }
        } else {
          this.$toasted.show('请先登录')
        }
      },
      startQuestionnaire (examPaperInfo, type, itemId) {
        if (getCookie(process.env.TOKEN_KEY) && getCookie(process.env.TOKEN_KEY) != '') {
          let state = this.$utils.judgmentState(examPaperInfo.startDate, examPaperInfo.endDate)
          if (state=='0') {
            let that = this
            if (examPaperInfo.examId && examPaperInfo.examId!='' && examPaperInfo.remainTime>0) {
              this.$modal.show('dialog', {
                title: '提示',
                text: '该问卷存在未完成记录，是否继续？',
                buttons: [
                  {
                    title: '继续',
                    default: true,
                    handler: () => {
                      var itemRecordId = that.getItemRecordIdBy(itemId)
                      that.$modal.hide('dialog')
                      that.$api.post(that.$global.bylApiPath, '/planUsers/saveExamId', {examId: examPaperInfo.examId, id: itemRecordId}, r => {
                        that.$router.push({path: that.path + '/questionnaireStart/' + examPaperInfo.examId + '/' + type + '/' + examPaperInfo.id})
                      })
                    }
                  },
                  {
                    title: '重新开始',
                    handler: () => {
                      that.$api.post(that.$global.examApiPath, '/examExamScore/getExamId', {paperId: examPaperInfo.id}, r => {
                        if (r.data) {
                          var examId = r.data
                          var itemRecordId = that.getItemRecordIdBy(itemId)
                          that.$modal.hide('dialog')
                          that.$api.post(that.$global.bylApiPath, '/planUsers/saveExamId', {examId: r.data, id: itemRecordId}, r => {
                            that.$router.push({path: that.path + '/questionnaireStart/' + examId + '/' + type + '/' + examPaperInfo.id})
                          })
                        }
                      })
                    }
                  }
                ]
              })
            } else { // 重新开始
              that.$api.post(that.$global.examApiPath, '/examExamScore/getExamId', {paperId: examPaperInfo.id}, r => {
                if (r.data) {
                  var examId = r.data
                  var itemRecordId = that.getItemRecordIdBy(itemId)
                  that.$api.post(that.$global.bylApiPath, '/planUsers/saveExamId', {examId: r.data, id: itemRecordId}, r => {
                    that.$router.push({path: that.path + '/questionnaireStart/' + examId + '/' + type + '/' + examPaperInfo.id})
                  })
                }
              })
            }
          } else if (state=='1') {
            this.$toasted.show('该问卷已结束', {
              duration: 1000
            })
          } else if (state=='2') {
            this.$toasted.show('该问卷未开放', {
              duration: 1000
            })
          } else if (state=='-1') {
            this.$toasted.show('该问卷开始时间或结束时间有误', {
              duration: 1000
            })
          }
        } else {
          this.$toasted.show('请先登录！', {
            duration: 800
          })
        }
      },
      sortFinished (arr) {
        let finished = arr.filter((item, idx) => {
          let process = this.getProcess(item.itemId)
          return process == 100
        })
        var l = difference(arr, finished, 'id')  // 求差集
        return l.concat(finished)
      }
    }
  }
</script>

<style scoped>
  .detail_btn {
    width: 116px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    color: #58acfa;
    display: block;
    border: 1px solid #58acfa;
    border-radius: 30px;
    position: absolute;
    top: 75px;
    right: 0;
  }
</style>



// WEBPACK FOOTER //
// src/page/modules/plan/record.vue